"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClaimableAmounts = exports.useGetPreciseClaimableAmounts = void 0;
const lodash_zip_1 = __importDefault(require("lodash.zip"));
const react_1 = require("react");
const useGetPreciseClaimableAmounts = (rates) => {
    return (0, react_1.useMemo)(() => {
        if (!rates || !rates.amountsT0.sum) {
            return () => null;
        }
        const initialTotalAmount = parseFloat(rates.amountsT0.sum.toExact());
        const initialPoolAmounts = (0, lodash_zip_1.default)(rates.amountsT0.allClaimable.map((c) => c ? parseFloat(c.toExact()) : null), rates.pools);
        return () => {
            const secondsElapsed = (Date.now() - rates.timeT0Ms) / 1000;
            const pools = initialPoolAmounts.map(([initialPoolAmount, poolRatePerSecond]) => typeof initialPoolAmount === "number" &&
                typeof poolRatePerSecond === "number"
                ? initialPoolAmount + poolRatePerSecond * secondsElapsed
                : null);
            const total = initialTotalAmount + rates.total * secondsElapsed;
            return {
                pools,
                total,
            };
        };
    }, [rates]);
};
exports.useGetPreciseClaimableAmounts = useGetPreciseClaimableAmounts;
const useClaimableAmounts = (getter) => {
    const [amounts, setAmounts] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const interval = setInterval(() => {
            setAmounts(getter());
        }, 8);
        return () => clearInterval(interval);
    }, [getter]);
    return amounts;
};
exports.useClaimableAmounts = useClaimableAmounts;
//# sourceMappingURL=calculateClaimableAmounts.js.map